import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class OverlayService {
  overlayDisplay = new BehaviorSubject<boolean>(false);

  setOverlayDisplay(overlayDisplay: boolean) {
    this.overlayDisplay.next(overlayDisplay);
  }
}
